// URL param keys of the report filter dropdown (filters-v2 / useTableFilters).
export const REPORT_FILTER_KEY_MEMBER = 'member';
export const REPORT_FILTER_KEY_DEPARTMENT = 'department';
export const REPORT_FILTER_KEY_ROLE = 'role';
export const REPORT_FILTER_KEY_SENIORITY = 'seniority';
export const REPORT_FILTER_KEY_MEMBER_MANAGER = 'memberManager';
export const REPORT_FILTER_KEY_MEMBERSHIP_TYPE = 'membershipType';
export const REPORT_FILTER_KEY_COUNTRY = 'country';
export const REPORT_FILTER_KEY_CITY = 'city';
export const REPORT_FILTER_KEY_PROJECT = 'project';
export const REPORT_FILTER_KEY_CLIENT = 'client';
export const REPORT_FILTER_KEY_PROJECT_STATUS = 'projectStatus';
export const REPORT_FILTER_KEY_PROJECT_MANAGER = 'projectManager';
export const REPORT_FILTER_KEY_BILLING_MODEL = 'billingModel';
